export const baseUrl =
  process.env.NODE_ENV === "production"
    ? "https://rugdoctornzb2b.co.nz/api"
    : "http://rugb2b.onfire/api";

export const machineStatuses = [
  "Available",
  "Call Centre",
  "Issue",
  "In Transit",
  "Missing",
  "On Hire",
  "Overdue",
  "Stolen",
  "Unavailable",
  "Warehouse"
];



// WEBPACK FOOTER //
// ./src/backend/constants.js